// extracted by mini-css-extract-plugin
export default {"user_box":"UserMenu_user_box__Pn06b","user_name":"UserMenu_user_name__3MFob","button":"UserMenu_button__310Zp"};